"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get EmployeeStatusFilters () {
        return EmployeeStatusFilters;
    },
    get EmployeeStatusFiltersEnum () {
        return EmployeeStatusFiltersEnum;
    },
    get FieldCategory () {
        return FieldCategory;
    },
    get FieldType () {
        return FieldType;
    },
    get FieldTypeEnum () {
        return FieldTypeEnum;
    },
    get FilterComparison () {
        return FilterComparison;
    },
    get FilterComparisonEnum () {
        return FilterComparisonEnum;
    },
    get QuickFilterType () {
        return QuickFilterType;
    },
    get ReportingAggregationOperationTypes () {
        return ReportingAggregationOperationTypes;
    },
    get ReportingAggregationOperationTypesEnum () {
        return ReportingAggregationOperationTypesEnum;
    },
    get ReportingType () {
        return ReportingType;
    },
    get ReviewCycleStatusFilters () {
        return ReviewCycleStatusFilters;
    },
    get ReviewCycleStatusFiltersEnum () {
        return ReviewCycleStatusFiltersEnum;
    },
    get ReviewReportStatusFilters () {
        return ReviewReportStatusFilters;
    },
    get ReviewReportStatusFiltersEnum () {
        return ReviewReportStatusFiltersEnum;
    },
    get ReviewStatusFilters () {
        return ReviewStatusFilters;
    },
    get ReviewStatusFiltersEnum () {
        return ReviewStatusFiltersEnum;
    },
    get SummarizeByRowTypes () {
        return SummarizeByRowTypes;
    },
    get SummarizeByRowTypesEnum () {
        return SummarizeByRowTypesEnum;
    },
    get SummaryFunction () {
        return SummaryFunction;
    },
    get SummaryFunctionEnum () {
        return SummaryFunctionEnum;
    }
});
const _zod = require("zod");
var FilterComparison = /*#__PURE__*/ function(FilterComparison) {
    FilterComparison["Equals"] = "eq";
    FilterComparison["Between"] = "between";
    FilterComparison["GreaterThan"] = "gt";
    FilterComparison["GreaterThanOrEqual"] = "gte";
    FilterComparison["LessThan"] = "lt";
    FilterComparison["After"] = "after";
    FilterComparison["Before"] = "before";
    FilterComparison["LessThanOrEqual"] = "lte";
    FilterComparison["NotEqual"] = "ne";
    FilterComparison["Contains"] = "contains";
    FilterComparison["NotContains"] = "notcontains";
    FilterComparison["StartsWith"] = "startswith";
    FilterComparison["NotStartsWith"] = "notstartswith";
    FilterComparison["EndsWith"] = "endswith";
    FilterComparison["NotEndsWith"] = "notendswith";
    FilterComparison["Null"] = "null";
    return FilterComparison;
}({});
const FilterComparisonEnum = _zod.z.enum(FilterComparison);
var FieldType = /*#__PURE__*/ function(FieldType) {
    FieldType["People"] = "people";
    FieldType["Person"] = "person";
    FieldType["Text"] = "text";
    FieldType["Email"] = "email";
    FieldType["Phone"] = "phone";
    FieldType["Date"] = "date";
    FieldType["MultiSelect"] = "multi-select";
    FieldType["Numeric"] = "numeric";
    FieldType["SingleSelect"] = "single-select";
    FieldType["Monetary"] = "monetary";
    FieldType["Textbox"] = "textbox";
    // eslint-disable-next-line id-blacklist
    FieldType["Boolean"] = "boolean";
    FieldType["Template"] = "template";
    FieldType["Department"] = "department";
    FieldType["Cycle"] = "cycle";
    FieldType["Review"] = "review";
    FieldType["Status"] = "status";
    FieldType["Subject"] = "subject";
    FieldType["reviewReportStatus"] = "reviewReportStatus";
    FieldType["EmployeeStatus"] = "employeeStatus";
    FieldType["GoalStatus"] = "goalStatus";
    FieldType["GoalTransparency"] = "goalTransparency";
    FieldType["GoalOutlook"] = "goalOutlook";
    FieldType["GoalCategories"] = "goalCategories";
    FieldType["GoalAssignee"] = "goalAssignee";
    FieldType["GoalAlignment"] = "goal";
    FieldType["ResponseStatus"] = "responseStatus";
    FieldType["SurveyName"] = "surveyName";
    return FieldType;
}({});
const FieldTypeEnum = _zod.z.enum(FieldType);
const FieldCategory = _zod.z.enum([
    "GOAL_FIELD",
    "EMPLOYEE_FIELD",
    "REVIEW_FIELD",
    "REVIEW_CYCLE_FIELD",
    "REVIEW_FORM_FIELD",
    "REVIEW_REPORT_FIELD",
    "GROUPED_QUESTION",
    "SUBJECT",
    "SURVEY_FIELD"
]);
const ReportingType = _zod.z.enum([
    "employeeReport",
    "reviewReport",
    "employee",
    "goalReport",
    "surveyReport"
]);
const QuickFilterType = _zod.z.enum([
    "allReviews",
    "startedBetween",
    "completedBetween",
    "reviewReportStatus",
    "reviewStatus",
    "department",
    "reviewCycleNames",
    "reviewFormNames"
]);
var SummarizeByRowTypes = /*#__PURE__*/ function(SummarizeByRowTypes) {
    SummarizeByRowTypes["GOAL"] = "GOAL_FIELD";
    SummarizeByRowTypes["EMPLOYEE"] = "EMPLOYEE_FIELD";
    SummarizeByRowTypes["REVIEW_CYCLE"] = "REVIEW_CYCLE_FIELD";
    SummarizeByRowTypes["REVIEW_FIELD"] = "REVIEW_FIELD";
    SummarizeByRowTypes["REVIEW_FORM_FIELD"] = "REVIEW_FORM_FIELD";
    SummarizeByRowTypes["UNIQUE_QUESTION"] = "UNIQUE_QUESTION";
    SummarizeByRowTypes["SURVEY"] = "SURVEY_FIELD";
    return SummarizeByRowTypes;
}({});
const SummarizeByRowTypesEnum = _zod.z.enum(SummarizeByRowTypes);
var SummaryFunction = /*#__PURE__*/ function(SummaryFunction) {
    SummaryFunction["Average"] = "average";
    SummaryFunction["Sum"] = "sum";
    SummaryFunction["Minimum"] = "minimum";
    SummaryFunction["Maximum"] = "maximum";
    SummaryFunction["Count"] = "count";
    SummaryFunction["Concatenate"] = "concatenate";
    SummaryFunction["MissingSummaryFunction"] = "none";
    return SummaryFunction;
}({});
const SummaryFunctionEnum = _zod.z.enum(SummaryFunction);
var ReportingAggregationOperationTypes = /*#__PURE__*/ function(ReportingAggregationOperationTypes) {
    ReportingAggregationOperationTypes["EMPLOYEE"] = "EMPLOYEE_FIELD";
    ReportingAggregationOperationTypes["REVIEW_CYCLE"] = "REVIEW_CYCLE_FIELD";
    ReportingAggregationOperationTypes["REVIEW_FIELD"] = "REVIEW_FIELD";
    ReportingAggregationOperationTypes["REVIEW_FORM_FIELD"] = "REVIEW_FORM_FIELD";
    ReportingAggregationOperationTypes["UNIQUE_QUESTION"] = "UNIQUE_QUESTION";
    return ReportingAggregationOperationTypes;
}({});
const ReportingAggregationOperationTypesEnum = _zod.z.enum(ReportingAggregationOperationTypes);
var ReviewStatusFilters = /*#__PURE__*/ function(ReviewStatusFilters) {
    ReviewStatusFilters["Completed"] = "Completed";
    ReviewStatusFilters["Active"] = "Active";
    ReviewStatusFilters["Scheduled"] = "Scheduled";
    return ReviewStatusFilters;
}({});
const ReviewStatusFiltersEnum = _zod.z.enum(ReviewStatusFilters);
var ReviewCycleStatusFilters = /*#__PURE__*/ function(ReviewCycleStatusFilters) {
    ReviewCycleStatusFilters["Completed"] = "completed";
    ReviewCycleStatusFilters["Active"] = "active";
    ReviewCycleStatusFilters["Scheduled"] = "scheduled";
    return ReviewCycleStatusFilters;
}({});
var EmployeeStatusFilters = /*#__PURE__*/ function(EmployeeStatusFilters) {
    EmployeeStatusFilters["Active"] = "Active";
    EmployeeStatusFilters["Deactivated"] = "Deactivated";
    return EmployeeStatusFilters;
}({});
const EmployeeStatusFiltersEnum = _zod.z.enum(EmployeeStatusFilters);
const ReviewCycleStatusFiltersEnum = _zod.z.enum(ReviewCycleStatusFilters);
var ReviewReportStatusFilters = /*#__PURE__*/ function(ReviewReportStatusFilters) {
    ReviewReportStatusFilters["Completed"] = "completed";
    ReviewReportStatusFilters["Deleted"] = "deleted";
    ReviewReportStatusFilters["InProgress"] = "in-progress";
    ReviewReportStatusFilters["InProgressAwaitingSubmission"] = "in-progress-awaiting-authors";
    ReviewReportStatusFilters["InProgressAwaitingSignOff"] = "in-progress-awaiting-signoff";
    ReviewReportStatusFilters["NotStarted"] = "not-started";
    return ReviewReportStatusFilters;
}({});
const ReviewReportStatusFiltersEnum = _zod.z.enum(ReviewReportStatusFilters);
